const uuidv1 = require('uuid');

export function createPayload (action, type, payload) {
    return {
      action,
      requestID: uuidv1.v1(),
      type,
      payload
    };
  }